<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { InsuranceProducts } from '~~/server/api/insurance/bank/insurance'

export interface LazyPagesBankInsuranceProducts {
    data: InsuranceProducts
}

const props = defineProps<LazyPagesBankInsuranceProducts>()
</script>
<template>
  <section
    id="poistne-produkty"
    class="scroll-margin-top-11"
  >
    <Box
      decor-position="top-left"
      color="purple"
      padding="px-6 py-10 p-lg-15"
    >
      <article>
        <BoxHeader
          heading-level="h2"
          :heading="props.data.title"
        />
        <h3 class="gamma mb-4">
          {{ props.data.subtitle }}
        </h3>
        <Typo>
          <div v-html="props.data.description" />
        </Typo>
      </article>
    </Box>
  </section>
</template>
